var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "new-user-form" },
            [
              _c(
                "h4",
                { staticClass: "new-user-form__header col-form-label-lg" },
                [_vm._t("form-header")],
                2
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "new-user-form__group",
                  attrs: {
                    "label-size": "lg",
                    "label-class": "adduserlabel",
                    label: "Full Name",
                    "label-for": "fullName",
                    horizontal: false
                  }
                },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|max:255",
                        expression: "'required|max:255'"
                      }
                    ],
                    attrs: {
                      "data-vv-name": "user-" + _vm.id + ".fullName",
                      "data-vv-as": "Full Name",
                      size: "lg",
                      id: "fullName"
                    },
                    model: {
                      value: _vm.user.fullName,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "fullName", $$v)
                      },
                      expression: "user.fullName"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValidationErrors.has(
                            "user-" + _vm.id + ".fullName"
                          ),
                          expression:
                            "inputValidationErrors.has(`user-${id}.fullName`)"
                        }
                      ],
                      staticClass: "text-info"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.inputValidationErrors.first(
                            "user-" + _vm.id + ".fullName"
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "new-user-form__group",
                  attrs: {
                    "label-size": "lg",
                    "label-class": "adduserlabel",
                    label: "Email Address",
                    "label-for": "emailAddress",
                    horizontal: false
                  }
                },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email|max:255|uniqueUserEmail",
                        expression: "'required|email|max:255|uniqueUserEmail'"
                      }
                    ],
                    attrs: {
                      id: "emailAddress",
                      size: "lg",
                      "data-vv-name": "user-" + _vm.id + ".emailAddress",
                      "data-vv-as": "Email Address",
                      autocomplete: "email"
                    },
                    model: {
                      value: _vm.user.emailAddress,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "emailAddress", $$v)
                      },
                      expression: "user.emailAddress"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValidationErrors.has(
                            "user-" + _vm.id + ".emailAddress"
                          ),
                          expression:
                            "inputValidationErrors.has(`user-${id}.emailAddress`)"
                        }
                      ],
                      staticClass: "text-info"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.inputValidationErrors.first(
                            "user-" + _vm.id + ".emailAddress"
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "new-user-form__group",
                  attrs: {
                    "label-size": "lg",
                    "label-class": "adduserlabel",
                    label: "Active",
                    "label-for": "active",
                    horizontal: false
                  }
                },
                [
                  _c("b-form-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      "data-vv-name": "user-" + _vm.id + ".active",
                      "data-vv-as": "Active",
                      size: "lg",
                      value: _vm.user.isRemoved
                        ? "Deactivate"
                        : _vm.user.active,
                      options: _vm.getUserActiveOptions(
                        _vm.isSuperAdminOptions
                      ),
                      id: "active"
                    },
                    on: { change: _vm.handleSelect }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValidationErrors.has(
                            "user-" + _vm.id + ".active"
                          ),
                          expression:
                            "inputValidationErrors.has(`user-${id}.active`)"
                        }
                      ],
                      staticClass: "text-info"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.inputValidationErrors.first(
                            "user-" + _vm.id + ".active"
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "new-user-form__group",
                  attrs: {
                    "label-size": "lg",
                    "label-class": "adduserlabel",
                    label: "Super Admin",
                    "label-for": "isSuperAdmin",
                    horizontal: false
                  }
                },
                [
                  _c("b-form-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      "data-vv-name": "user-" + _vm.id + ".isSuperAdmin",
                      "data-vv-as": "is Super Admin",
                      size: "lg",
                      options: _vm.isSuperAdminOptions,
                      id: "isSuperAdmin"
                    },
                    model: {
                      value: _vm.user.isSuperAdmin,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "isSuperAdmin", $$v)
                      },
                      expression: "user.isSuperAdmin"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValidationErrors.has(
                            "user-" + _vm.id + ".isSuperAdmin"
                          ),
                          expression:
                            "inputValidationErrors.has(`user-${id}.isSuperAdmin`)"
                        }
                      ],
                      staticClass: "text-info"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.inputValidationErrors.first(
                            "user-" + _vm.id + ".isSuperAdmin"
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "new-user-form__group",
                  attrs: {
                    "label-size": "lg",
                    "label-class": "adduserlabel",
                    label: "Password",
                    "label-for": "password",
                    horizontal: false
                  }
                },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value:
                          "" +
                          (_vm.passwordRequired
                            ? "required|min:8|max:255"
                            : "max:255|min:8"),
                        expression:
                          "`${passwordRequired ? 'required|min:8|max:255' : 'max:255|min:8'}`"
                      }
                    ],
                    attrs: {
                      id: "password",
                      type: "password",
                      "data-vv-name": "user-" + _vm.id + ".password",
                      "data-vv-as": "Password",
                      autocomplete: "new-password",
                      size: "lg"
                    },
                    model: {
                      value: _vm.user.password,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "password", $$v)
                      },
                      expression: "user.password"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputValidationErrors.has(
                            "user-" + _vm.id + ".password"
                          ),
                          expression:
                            "inputValidationErrors.has(`user-${id}.password`)"
                        }
                      ],
                      staticClass: "text-info"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.inputValidationErrors.first(
                            "user-" + _vm.id + ".password"
                          )
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "new-user-form__group new-user-form__wrapper" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        "label-class": "adduserlabel",
                        label: "CSE-IT Trained?",
                        "label-for": "cse-it-trained",
                        horizontal: false
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "switch switch-lg switch-text switch-pill switch-primary-outline-alt mb-0 wide-toggle"
                        },
                        [
                          _c("input", {
                            staticClass: "switch-input",
                            attrs: { id: "positive_switch", type: "checkbox" },
                            domProps: { checked: _vm.user.isCseitTrained },
                            on: { change: _vm.toggleIsCseitTrained }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "switch-label",
                            attrs: {
                              "data-on": "CSE-IT Trained",
                              "data-off": "Not CSE-IT Trained"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "switch-handle" })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        "label-class": "adduserlabel",
                        label: "Organization Manager?",
                        "label-for": "isOrgManagerOff",
                        horizontal: false
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "switch switch-lg switch-text switch-pill switch-primary-outline-alt mb-0 wide-toggle"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.user.membership.isManager,
                                expression: "user.membership.isManager"
                              }
                            ],
                            staticClass: "switch-input",
                            attrs: { id: "positive_switch", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.user.membership.isManager
                              )
                                ? _vm._i(_vm.user.membership.isManager, null) >
                                  -1
                                : _vm.user.membership.isManager
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.user.membership.isManager,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.user.membership,
                                        "isManager",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.user.membership,
                                        "isManager",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.user.membership,
                                    "isManager",
                                    $$c
                                  )
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "switch-label",
                            attrs: { "data-on": "Yes", "data-off": "No" }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "switch-handle" })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        "label-class": "adduserlabel",
                        label: "Care Coordinator?",
                        "label-for": "isCareCoordinatorOff",
                        horizontal: false
                      }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "switch switch-lg switch-text switch-pill switch-primary-outline-alt mb-0 wide-toggle"
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.user.membership.isCareCoordinator,
                                expression: "user.membership.isCareCoordinator"
                              }
                            ],
                            staticClass: "switch-input",
                            attrs: { id: "positive_switch", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.user.membership.isCareCoordinator
                              )
                                ? _vm._i(
                                    _vm.user.membership.isCareCoordinator,
                                    null
                                  ) > -1
                                : _vm.user.membership.isCareCoordinator
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.user.membership.isCareCoordinator,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.user.membership,
                                        "isCareCoordinator",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.user.membership,
                                        "isCareCoordinator",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.user.membership,
                                    "isCareCoordinator",
                                    $$c
                                  )
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "switch-label",
                            attrs: { "data-on": "Yes", "data-off": "No" }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "switch-handle" })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36b19737", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36b19737","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/Admin/NewUserForm.vue
// module id = 1839
// module chunks = 0